import { useState } from "react";
import { ITask } from "../../../data_models/task";
import Lightbox from "../../common/Lightbox";
import { FilledButton, OutlinedButton } from "../../common/Button";
import useTasks from "../../../hooks/useTasks";
import useDisplayNotifications from "../../../hooks/useDisplayNotifications";
import { DisplayNotificationType } from "../../../models/DisplayNotification";
import useProjectManagement from "../../../hooks/useProjectManagement";
import { IProject } from "../../../data_models/project";

interface AcceptTaskDeliveryLightboxPropsProps {
    onClose: () => void;
    task: ITask;
    onUpdateTask: (updatedTask: ITask) => void;
    onUpdateProject: (updatedProject: IProject) => void;
}

const AcceptTaskDeliveryLightboxProps: React.FC<AcceptTaskDeliveryLightboxPropsProps> = ({ onClose, task, onUpdateTask, onUpdateProject }) => {

    const [loading, setLoading] = useState(false);

    const { completeTask } = useTasks();
    const { addSuccessNotification, addErrorNotification } = useDisplayNotifications();
  
    const onAcceptDelivery = async () => {
        setLoading(true);
        await completeTask(task._id!).then((updated) => {
            onUpdateTask(updated.task);
            onUpdateProject(updated.project);
            addSuccessNotification(`Successfully accepted delivery for ${task.title}.`);
        }).catch((error) => {
            addErrorNotification(error.message, "Could not accept delivery");
        }).finally(() => {
            setLoading(false);
            onClose();
        });
    }
    return (

        <Lightbox
            header="Accept Delivery"
            onCancel={onClose}
            onConfirm={onAcceptDelivery}
            loadingConfirm={loading}
            content={
                <p>Make sure the talent has met all the “definition of done” criteria and the final delivery is ready. Once you confirm completion, the talent will be paid and may no longer continue work on this task.</p>
            }
            onClose={onClose}
        />

    );
}

export default AcceptTaskDeliveryLightboxProps;